 
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaRegClock } from 'react-icons/fa';

import { formatTime } from 'utils/formatter';

import Text from 'v3/components/Text';

function Modal({ alerts }) {
  return (
    <Row md={12}>
      {alerts &&
        alerts.map((alert, index) => (
          <Col
            md={12}
            className="px-5 my-2"
            key={alert.id || `${alert.captured_at}-${index}`}
          >
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}
            >
              <FaRegClock color="#464E5F" />
              <Text color="dark" type="regular" style={{ marginBottom: 0 }}>
                {formatTime(alert.captured_at)}
              </Text>
              <Text color="gray" type="regular" style={{ marginBottom: 0 }}>
                - Acima de 80km/h.
              </Text>
            </div>
          </Col>
        ))}
    </Row>
  );
}

export default Modal;
